import { DataTableValue } from 'primereact/datatable';
import { Dataset } from '../../../../types/types';
import { isSkeletonRow } from './isSkeletonRow';
import { getRowStyleClassNames } from './getRowStyleClassNames';

export const getRowClassName = (
  rowData: DataTableValue,
  dataKey: string,
  expandedRow: DataTableValue | undefined,
  dataset: Dataset
): string => {
  if (isSkeletonRow(rowData[dataKey])) {
    return 'skeletonRow';
  }

  const styleClasses = getRowStyleClassNames(rowData, dataset);
  // Match by dataKey, not reference: a reload swaps in fresh row objects, so a
  // reference check would drop the highlight while the row stays expanded.
  const isExpanded =
    !!expandedRow && String(expandedRow[dataKey]) === String(rowData[dataKey]);

  const classes = [isExpanded ? 'singleSelectRow' : '', styleClasses].filter(
    Boolean
  );

  return classes.join(' ');
};
